const bubblesData = [
  // languages
  {
    id: 1,
    className: "bubble bubble-sm bubble-c",
    src: "images/c.svg",
    alt: "C"
  },
  {
    id: 2,
    className: "bubble bubble-xlg bubble-python",
    src: "images/python.svg",
    alt: "Python"
  },
  {
    id: 3,
    className: "bubble bubble-md-lg bubble-js",
    src: "images/javascript.svg",
    alt: "Javascript"
  },
  {
    id: 4,
    className: "bubble bubble-lg bubble-java",
    src: "images/java.svg",
    alt: "Java"
  },
  {
    id: 5,
    className: "bubble bubble-sm-md bubble-cpp",
    src: "images/cpp.svg",
    alt: "C++"
  },
  {
    id: 6,
    className: "bubble bubble-md bubble-ps",
    src: "images/powershell.svg",
    alt: "Powershell"
  },
  // front-end
  {
    id: 7,
    className: "bubble bubble-xlg bubble-css",
    src: "images/css.svg",
    alt: "CSS"
  },
  {
    id: 8,
    className: "bubble bubble-md bubble-redux",
    src: "images/redux.svg",
    alt: "Redux"
  },
  {
    id: 9,
    className: "bubble bubble-sm-md bubble-axios",
    src: "images/axios.svg",
    alt: "Axios"
  },
  {
    id: 10,
    className: "bubble bubble-md-lg bubble-react",
    src: "images/react.svg",
    alt: "React"
  },
  {
    id: 11,
    className: "bubble bubble-lg bubble-html5",
    src: "images/html5.svg",
    alt: "HTML5"
  },
  {
    id: 12,
    className: "bubble bubble-sm bubble-less",
    src: "images/less.svg",
    alt: "Less"
  },
  // back-end
  {
    id: 13,
    className: "bubble bubble-md bubble-knex",
    src: "images/knex.svg",
    alt: "Knex"
  },
  {
    id: 14,
    className: "bubble bubble-sm-md bubble-stripe",
    src: "images/StripeWhite.svg",
    alt: "Stripe"
  },
  {
    id: 15,
    className: "bubble bubble-xlg bubble-rest",
    src: "images/restfulapi.svg",
    alt: "Rest"
  },
  {
    id: 16,
    className: "bubble bubble-sm bubble-nodejs",
    src: "images/nodejs.svg",
    alt: "Nodejs"
  },
  {
    id: 17,
    className: "bubble bubble-md-lg bubble-express",
    src: "images/express.svg",
    alt: "Express"
  },
  {
    id: 18,
    className: "bubble bubble-lg bubble-postgresql",
    src: "images/postgresql.svg",
    alt: "PostgreSQL"
  },
]

export {
  bubblesData
}